import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createScreenshotFailed, createScreenshotSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createScreenshot(action) {
  try {
    const id = action.payload;
    const url = `${BACKEND_URL}/camera/${id}/screenshot`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(createScreenshotSuccessful());
      const timestamp = dataResponse.headers.get('X-Snapshot-Timestamp') || '';
      yield call(resolveActionPromise(action, { data, timestamp }));
    } else {
      const data = yield dataResponse.json();
      yield put(createScreenshotFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createScreenshotFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
